import axios from 'axios';
import config from '../config';
import { ProcessingBuildListItem } from '../interfaces';
import { DEFAULT_TILE_SOURCE_OPTIONS } from '../constants/tileSourceOptions';

export interface ProcessingBuildsResponse {
    builds: ProcessingBuildListItem[];
    tileSourceOptions: string[];
}

export const getProcessingBuilds = (): Promise<ProcessingBuildsResponse> => {
    const url = `${config.API_URL}/maps/processing-builds`;

    return axios.get(url).then((response: any) => {
        const data = response.data?.data;
        const builds = Array.isArray(data) ? data : data?.builds;
        const tileSourceOptions = data?.tileSourceOptions;

        return {
            builds: Array.isArray(builds) ? builds : [],
            tileSourceOptions:
                Array.isArray(tileSourceOptions) && tileSourceOptions.length > 0
                    ? tileSourceOptions
                    : DEFAULT_TILE_SOURCE_OPTIONS,
        };
    });
};
